import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const questions = [
    {
      question: 'How long is the experience?',
      answer: 'The full Sigiriya VR experience lasts approximately 10 minutes, including onboarding.',
    },
    {
      question: 'Is prior VR experience required?',
      answer: 'Not at all! Our team provides guidance, making it accessible for first-time users.',
    },
    {
      question: 'Is it available in multiple languages?',
      answer: 'Yes. Currently, Sigiriya VR is available in English, French, and German only. Chinese, Russian, Hindi, and more languages are coming soon.',
    },
    {
      question: 'Is it historically accurate?',
      answer: 'Yes! Every scene has been carefully reconstructed with input from historians and archaeological research.',
    },
    {
      question: 'Can I wear glasses with the VR headset?',
      answer: 'Yes, our headsets accommodate most prescription glasses.',
    },
  ];

  return (
    <div className="bg-[#fdf4e4] py-8 px-6 md:px-16">
      <div className="flex flex-col md:flex-row items-center justify-between gap-12">
        
        {/* Image - Hidden on mobile */}
        <div className="hidden md:block md:w-2/5">
          <img 
            src={require('../assets/images/kasspa.png')} 
            alt="Sigiriya King" 
            className="w-70 h-auto object-contain"
          />
        </div>

        {/* FAQ Section */}
        <div className="w-full md:w-3/5">
          <h2 className="text-2xl md:text-3xl font-bold md:text-left text-[#3f3a32] mb-8 font-mortend headings">
            GOT QUESTIONS? WE’VE GOT ANSWERS
          </h2>

          <div className="space-y-4">
            {questions.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className="border-b border-[#d8cbb5] pb-2 cursor-pointer"
                  onClick={() => toggleFAQ(index)}
                >
                  <div className="flex justify-between items-center text-[#3f3a32] text-lg font-medium">
                    <span>{item.question}</span>
                    {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                  </div>

                  <div
                    className={`overflow-hidden transition-all duration-300 ease-in-out ${
                      isOpen ? 'max-h-40 opacity-100 mt-2' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div className="text-[#5a5a5a] font-ltremark text-base">
                      {item.answer}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
